import { MutationTree } from 'vuex';
import AppState from '@/store/modules/app/types/AppState';

const mutations: MutationTree<AppState> = {
  locale(state, locale: string) {
    state.locale = locale;
  },

  error(state, error: any = {}) {
    state.error = error;
  },
};

export default mutations;
